import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import ShareBtn from 'components/ShareBtn';
import PrintIcon from 'svg/print.svg';
import styles from './PDFViewer.pcss';
const Actions = ({ fileUrl, onPrint })=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.viewer__bottomNavIcon,
                children: /*#__PURE__*/ _jsx(ShareBtn, {
                    url: fileUrl,
                    text: "Share"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.viewer__bottomNavIcon,
                children: /*#__PURE__*/ _jsx(PrintIcon, {
                    onClick: onPrint
                })
            })
        ]
    });
};
export default Actions;
